module.exports = __webpack_public_path__ + "media/images/front/programs/icon-sort-active-5cc9eef40ef0beea088405aab94e7144.svg";